import { Box } from "@mui/material";
import Layout from "../components/layout/Layout";
import EmployeeAvailabilityCalendar from "../components/availability/EmployeeAvailabilityCalendar";
import { useEmployees } from "../hooks/useEmployees";
import { useOrganization } from "../context/OrganizationContext";

export default function EmployeesAvailabilityPage() {
  const { canWrite, organization } = useOrganization();
  const { employees, isLoading: isLoadingEmployees } = useEmployees();

  const allowEditHistory = organization?.settings?.allowEditHistory ?? false;

  return (
    <Layout pageTitle="Employee Availability">
      <Box>
        {/* Calendar View */}
        <EmployeeAvailabilityCalendar
          employees={employees}
          isLoading={isLoadingEmployees}
          canWrite={canWrite}
          allowEditHistory={allowEditHistory}
        />
      </Box>
    </Layout>
  );
}
